export default __webpack_public_path__ + "static/media/imghomepagebanner 2.7de24a09.webp";